// extracted by mini-css-extract-plugin
export default {"noCreditsContainer":"NoEnoughCredits_noCreditsContainer__3uy82","noCreditsText":"NoEnoughCredits_noCreditsText__FRBaA"};